<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">举报管理</div>

    <!-- 查询条件 -->
    <div class="search-wrapper">
      <el-form
        :inline="true"
        :model="queryParam"
        label-width="82px"
        class="search-row"
      >
        <el-form-item label="动态ID">
          <el-input
            v-model="queryParam.dynamicId"
            placeholder="精确搜索"
            clearable
            style="width: 160px"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input
            v-model="queryParam.userId"
            placeholder="精确搜索"
            clearable
            style="width: 160px"
          ></el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input
            v-model="queryParam.nickName"
            placeholder="模糊搜索"
            clearable
            style="width: 160px"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-date-picker
            clearable
            v-model="queryParam.publishTime"
            type="datetimerange"
            range-separator="至"
            placeholder="请选择开始时间至结束时间"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 380px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item class="search-action-item">
          <el-button @click="clickReset">重置</el-button>
          <el-button type="primary" @click="clickSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="content-wrapper">
      <el-button-group style="margin-bottom: 20px">
        <el-button
          v-for="tab in statusTabs"
          :key="tab.value"
          :class="[
            'status-tab-btn',
            { 'is-active': queryParam.reportTab === tab.value },
          ]"
          @click="setTab(tab.value)"
          >{{ tab.label }}</el-button
        >
      </el-button-group>
      <el-table ref="reportTable" :data="listData" border>
        <el-table-column
          prop="id"
          label="动态ID"
          min-width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="userId"
          label="用户ID"
          min-width="110"
          align="center"
        >
          <template scope="{ row }">
            <el-button type="text" @click="routeDynamicDetail(row)">
              {{ row.userId }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="nickname"
          label="昵称"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="authorTypeText"
          label="类型"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="content"
          label="内容"
          min-width="200"
          show-overflow-tooltip
        >
          <template scope="{ row }">
            <span v-if="row.content">{{ row.content }}</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column
          label="图片数量/视频时长"
          min-width="170"
          align="center"
        >
          <template scope="{ row }">
            <div v-if="row.images && row.images.length" class="media-cell">
              <div class="media-grid">
                <span class="media-item" @click="openMedia(mediaList(row), 0)">
                  <img
                    v-if="mediaList(row)[0].type === 'image'"
                    :src="mediaList(row)[0].url"
                    class="media-thumb"
                    alt="图片"
                  />
                  <span v-else class="media-video"
                    ><i class="media-play">▶</i></span
                  >
                  <div class="under-dot">
                    {{ (row && row.images && row.images.length) || "" }}
                  </div>
                </span>
              </div>
            </div>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column label="关联话题" min-width="160">
          <template scope="{ row }">
            <template v-if="row.topics && row.topics.length">
              <el-tag
                v-for="(t, i) in row.topics"
                :key="i"
                type="info"
                size="small"
                class="topic-tag"
                >{{ t.name || t.topicName }}</el-tag
              >
            </template>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sportsRecordText"
          label="跑步记录"
          min-width="330"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="publishedAt"
          label="发布时间"
          min-width="170"
          align="center"
          sortable
        ></el-table-column>
        <!-- 驳回原因：接口无独立“举报审核驳回原因”字段，暂映射动态本身 auditMsg（审核不通过原因），待后端确认是否另有返回字段 -->
        <el-table-column
          v-if="queryParam.reportTab === 3"
          prop="auditMsg"
          label="驳回原因"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="reportReason"
          label="举报原因"
          min-width="200"
        ></el-table-column>
        <el-table-column
          prop="reportTimeText"
          label="举报时间"
          min-width="170"
          align="center"
          sortable
          :sort-method="(a, b) => (a.reportTime || 0) - (b.reportTime || 0)"
        ></el-table-column>
        <el-table-column label="举报人" min-width="200">
          <template scope="{ row }"
            >{{ row.reportNickName || "无"
            }}{{ row.reportUid ? "（" + row.reportUid + "）" : "" }}</template
          >
        </el-table-column>
        <el-table-column
          v-if="queryParam.reportTab === 1"
          label="操作"
          min-width="100"
          align="center"
          fixed="right"
        >
          <template scope="{ row }">
            <el-button type="text" @click="openAudit(row)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper">
      <div v-show="total > 0" class="pagination-seq">
        <el-pagination
          layout="total, prev, pager, next"
          :current-page="queryParam.pageNum"
          :page-size="queryParam.pageSize"
          :total="total"
          @current-change="changeCurrentPage"
        ></el-pagination>
      </div>
    </div>

    <!-- 举报审核弹窗 -->
    <el-dialog
      title="动态审核"
      size="small"
      :visible.sync="auditDialog.visible"
      :modal-append-to-body="false"
      @close="resetAuditForm"
    >
      <el-form label-width="90px" v-if="auditDialog.row">
        <el-form-item label="动态ID">{{ auditDialog.row.id }}</el-form-item>
        <el-form-item label="举报原因">{{
          auditDialog.row.reportReason || "无"
        }}</el-form-item>
        <el-form-item label="审核状态" required>
          <el-radio-group v-model="auditDialog.form.auditStatus">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">不通过</el-radio>
          </el-radio-group>
          <div v-if="auditDialog.form.auditStatus === 1">
            通过后，帖子依然正常显示
          </div>
        </el-form-item>
        <template v-if="auditDialog.form.auditStatus === 2">
          <el-form-item label="驳回原因" required>
            <el-select
              v-model="auditDialog.form.rejectReason"
              placeholder="请选择驳回原因"
              style="width: 360px"
            >
              <el-option
                v-for="(r, i) in rejectReasons"
                :key="i"
                :label="r.label"
                :value="i + 1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="其他原因"
            v-if="auditDialog.form.rejectReason === 7"
          >
            <el-input
              type="textarea"
              v-model="auditDialog.form.customReason"
              placeholder="请输入驳回原因"
              style="width: 360px"
            ></el-input>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer">
        <el-button @click="auditDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="confirmAudit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 媒体预览（图片放大预览 / 视频放大播放，支持上一张/下一张切换） -->
    <el-dialog
      title="预览"
      :visible.sync="mediaPreview.visible"
      :modal-append-to-body="false"
      @close="closeMedia"
    >
      <div class="media-preview-body">
        <img
          v-if="currentMedia && currentMedia.type === 'image'"
          :src="currentMedia.url"
          class="media-preview"
          alt="预览"
        />
        <video
          v-else-if="currentMedia"
          :src="currentMedia.url"
          controls
          autoplay
          class="media-preview"
        ></video>
      </div>
      <div v-if="mediaPreview.list.length > 1" class="media-preview-nav">
        <el-button :disabled="mediaPreview.index === 0" @click="prevMedia"
          >上一个</el-button
        >
        <span class="media-preview-count">{{ mediaPreviewText }}</span>
        <el-button
          :disabled="mediaPreview.index === mediaPreview.list.length - 1"
          @click="nextMedia"
          >下一个</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 社区动态举报管理（运营后台 Apifox，2026-08-13 确认，v70370 前缀）
// 列表：POST /adminapi/v70370/community/dynamic/report/list  -> AdminReportListReqDTO / ResponseModelAdminReportListResDTO(data.list, data.totalCount)
// 审核：POST /adminapi/v70370/community/dynamic/report/audit  -> AdminDynamicAuditReportReqDTO { dynamicId, auditStatus(1通过/2不通过), auditReason }
// 列表项：AdminReportListItemDTO（继承社区动态DTO，追加 reportReason/reportTime/reportUid/reportNickName）
// 注意 Gap：
//  1) 列表入参 AdminReportListReqDTO 无排序字段，publishTime/reportTime 的“可排序”为 el-table 本地排序（仅当前页）
//  2) 驳回原因：接口无独立举报审核驳回字段，暂映射 auditMsg（动态审核不通过原因），待后端确认
//  3) 状态筛选用 el-button-group（待处理/已处理-通过/已处理-未通过），无“全部”选项，默认待处理(reportTab=1)；切换即带 reportTab 查询
export default {
  data() {
    return {
      loading: false,
      queryParam: this.getDefaultQueryParam(),
      total: 0,
      listData: [],
      auditDialog: {
        visible: false,
        row: null,
        form: this.getEmptyAuditForm(),
      },
      authorTypeMap: {
        1: "普通用户",
        2: "马甲号",
        3: "官方号",
        4: "校园主理人",
      },
      // 跑步模式：1=计分跑 4=自由跑（均称“校园跑”） 6=户外跑
      runModeMap: { 1: "校园跑", 4: "校园跑", 6: "户外跑" },
      // 状态筛选选项（el-button-group 遍历，无“全部”，默认待处理=1）
      statusTabs: [
        { label: "待处理", value: 1 },
        { label: "已处理-通过", value: 2 },
        { label: "已处理-未通过", value: 3 },
      ],
      // 驳回原因选项（审核选择“不通过”时展示）
      rejectReasons: [
        { label: "发布违规内容（涉政/暴恐/诈骗）" },
        { label: "色情低俗" },
        { label: "恶意刷屏/灌水" },
        { label: "骚扰/攻击他人" },
        { label: "广告/引流营销" },
        { label: "内容低质/抄袭" },
        { label: "其他" },
      ],
      // 媒体预览（图片放大预览 / 视频放大播放，支持上一张/下一张切换）
      mediaPreview: { visible: false, list: [], index: 0 },
    };
  },

  computed: {
    // 当前预览的媒体对象（根据 index 从列表中取）
    currentMedia() {
      const mp = this.mediaPreview;
      if (!mp.visible || !mp.list || !mp.list.length) {
        return null;
      }
      return mp.list[mp.index] || null;
    },
    // 预览计数文案，如「2 / 5」
    mediaPreviewText() {
      const mp = this.mediaPreview;
      if (!mp.list || !mp.list.length) {
        return "";
      }
      return `${mp.index + 1} / ${mp.list.length}`;
    },
  },

  mounted() {
    this.queryList();
  },

  methods: {
    getDefaultQueryParam() {
      return {
        pageNum: 1,
        pageSize: 20,
        reportTab: 1, // 默认待处理（1=待处理 2=已处理-通过 3=已处理-未通过），无“全部”选项
        dynamicId: "",
        userId: "",
        nickName: "",
        publishTime: [], // [publishTimeStart, publishTimeEnd]
      };
    },

    getEmptyAuditForm() {
      return {
        auditStatus: 1, // 1=通过 2=不通过
        rejectReason: "", // 选中的驳回原因序号 1-7
        customReason: "", // 选“其他”时的自定义文本
      };
    },

    // 列表查询：POST /adminapi/v70370/community/dynamic/report/list
    queryList() {
      this.loading = true;
      const params = {
        pageNum: this.queryParam.pageNum,
        pageSize: this.queryParam.pageSize,
      };
      if (this.queryParam.reportTab) {
        params.reportTab = this.queryParam.reportTab;
      }
      if (this.queryParam.dynamicId) {
        params.dynamicId = Number(this.queryParam.dynamicId);
      }
      if (this.queryParam.userId) {
        params.userId = Number(this.queryParam.userId);
      }
      if (this.queryParam.nickName) {
        params.nickName = this.queryParam.nickName;
      }
      if (
        this.queryParam.publishTime &&
        this.queryParam.publishTime.length === 2
      ) {
        // el-date-picker 在 element-ui 1.4 下 v-model 恒为 Date 对象（无 value-format），提交时转成字符串
        params.publishTimeStart = this.formatDateTime(
          this.queryParam.publishTime[0]
        );
        params.publishTimeEnd = this.formatDateTime(
          this.queryParam.publishTime[1]
        );
      }
      this.$http({
        url:
          this.$util.domain + "/adminapi/v70370/community/dynamic/report/list",
        method: "POST",
        body: JSON.stringify(params),
      })
        .then((res) => {
          const data = (res.data && res.data.data) || {};
          const list = data.list || [];
          this.listData = list.map(this.formatItem);
          this.total = data.totalCount || 0;
        })
        .catch(() => {
          this.listData = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 把后端列表项映射为表格行视图模型
    formatItem(item) {
      return {
        ...item,
        authorTypeText: this.authorTypeMap[item.authorType] || "无",
        mediaText: this.mediaText(item),
        topicsText: this.topicsText(item.topics),
        sportsRecordText: this.formatRunData(item.runData),
        publishedAt: item.publishedAt,
        publishedAtText: this.formatDateTime(item.publishedAt),
        reportTime: item.reportTime,
        reportTimeText: this.formatDateTime(item.reportTime),
        reportNickName: item.reportNickName,
        reportUid: item.reportUid,
      };
    },

    // 跑步记录：取 runData 按类型展示「校园跑 2.01公里；时长10:06； 配速5'01"； 消耗114千卡；」
    formatRunData(runData) {
      if (!runData) return "无";
      const typeName = this.runModeName(runData.runModeEnum);
      const dis =
        runData.totalDis != null
          ? `${Number(runData.totalDis / 1000).toFixed(2)}公里`
          : "";
      const dur = this.formatDuration(runData.totalTime);
      const pace = this.formatPace(runData.speed);
      const cal = runData.calorie != null ? `${runData.calorie}千卡` : "";
      return `${typeName} ${dis}；时长${dur}； 配速${pace}； 消耗${cal}；`;
    },

    runModeName(runModeEnum) {
      return (
        this.runModeMap[runModeEnum] || (runModeEnum != null ? "跑步" : "")
      );
    },

    formatDuration(sec) {
      if (sec == null) return "无";
      const s = Math.floor(sec);
      const h = Math.floor(s / 3600);
      const m = Math.floor((s % 3600) / 60);
      const ss = s % 60;
      const pad = (n) => String(n).padStart(2, "0");
      return h > 0 ? `${h}:${pad(m)}:${pad(ss)}` : `${pad(m)}:${pad(ss)}`;
    },

    formatPace(speed) {
      if (speed == null) return "无";
      // speed 单位：秒/公里；若 < 60 视为「分.秒」小数存储，兼容两种来源
      const totalSeconds = speed >= 60 ? speed : Math.round(speed * 60);
      const m = Math.floor(totalSeconds / 60);
      const s = totalSeconds % 60;
      const pad = (n) => String(n).padStart(2, "0");
      return `${m}'${pad(s)}"`;
    },

    mediaText(item) {
      const parts = [];
      if (item.images && item.images.length) {
        parts.push(`图片${item.images.length}张`);
      }
      if (item.videoDuration != null && item.videoDuration !== 0) {
        parts.push(`视频${item.videoDuration}s`);
      }
      return parts.length ? parts.join(" / ") : "无";
    },

    // 把后端 images 数组按 URL 后缀分流为图片/视频，供缩略图与预览渲染
    mediaList(row) {
      return (row.images || []).map((url) => ({
        url,
        type: this.getMediaType(url),
      }));
    },

    // 后缀判断：视频类后缀走 video，其余按图片处理
    getMediaType(url) {
      return /\.(mp4|webm|ogg|mov|avi|mkv)(\?.*)?$/i.test(url || "")
        ? "video"
        : "image";
    },

    // 打开预览，传入完整媒体列表与当前索引（支持上一张/下一张）
    openMedia(list, index) {
      this.mediaPreview = { visible: true, list: list, index: index };
    },

    // 上一张（已到第一张则不动）
    prevMedia() {
      if (this.mediaPreview.index > 0) {
        this.mediaPreview.index -= 1;
      }
    },

    // 下一张（已到最后一张则不动）
    nextMedia() {
      if (this.mediaPreview.index < this.mediaPreview.list.length - 1) {
        this.mediaPreview.index += 1;
      }
    },

    closeMedia() {
      this.mediaPreview = { visible: false, list: [], index: 0 };
    },

    topicsText(topics) {
      const names = (topics || [])
        .map((t) => t.name || t.topicName || "")
        .filter(Boolean);
      return names.length ? names.join("、") : "无";
    },

    formatDateTime(value) {
      if (!value) {
        return null;
      }
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return String(value);
      }
      const pad = (n) => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`;
    },

    clickSearch() {
      this.queryParam.pageNum = 1;
      this.queryList();
    },

    // 状态切换（el-button-group）：选中即带 reportTab 重新查询
    setTab(tab) {
      if (this.queryParam.reportTab === tab) {
        return;
      }
      this.queryParam.reportTab = tab;
      this.queryParam.pageNum = 1;
      this.queryList();
    },

    clickReset() {
      this.queryParam = this.getDefaultQueryParam();
      this.queryList();
    },

    changeCurrentPage(pageNum) {
      this.queryParam.pageNum = Number(pageNum) || 1;
      this.queryList();
    },

    openAudit(row) {
      if (!row) {
        return;
      }
      this.auditDialog.row = row;
      this.auditDialog.form = this.getEmptyAuditForm();
      this.auditDialog.visible = true;
    },

    resetAuditForm() {
      this.auditDialog.row = null;
      this.auditDialog.form = this.getEmptyAuditForm();
    },

    // 举报审核提交：POST /adminapi/v70370/community/dynamic/report/audit
    // auditReason：选择“不通过”时必填；1-6 取选项文案，7（其他）取自定义文本
    confirmAudit() {
      const form = this.auditDialog.form;
      const row = this.auditDialog.row;
      if (!row) {
        return;
      }
      if (form.auditStatus === 2) {
        if (!form.rejectReason) {
          this.$util.errorMsg("请选择驳回原因");
          return;
        }
        if (form.rejectReason === 7 && !form.customReason.trim()) {
          this.$util.errorMsg("请输入驳回原因");
          return;
        }
      }
      let auditReason = "";
      if (form.auditStatus === 2) {
        auditReason =
          form.rejectReason === 7
            ? form.customReason.trim()
            : this.rejectReasons[form.rejectReason - 1].label;
      }
      const payload = { dynamicId: row.id, auditStatus: form.auditStatus };
      if (auditReason) {
        payload.auditReason = auditReason;
      }
      this.loading = true;
      this.$http({
        url:
          this.$util.domain + "/adminapi/v70370/community/dynamic/report/audit",
        method: "POST",
        body: JSON.stringify(payload),
      })
        .then((res) => {
          const resp = res.data || res.body;
          if (resp && resp.error === 10000) {
            this.$util.successMsg("审核成功");
            this.auditDialog.visible = false;
            setTimeout(() => {
              this.queryList();
            }, 1000);
          } else {
            this.$util.errorMsg((resp && resp.message) || "审核失败");
          }
        })
        .catch((err) => {
          this.$util.errorMsg((err && err.message) || "审核失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    routeDynamicDetail(row) {
      window.open("/#/yunying/community/user/list?uid=" + row.userId);
    },
  },
};
</script>

<style scoped>
.search-wrapper {
  margin-bottom: 8px;
}

.search-row {
  margin-bottom: 0;
}

.search-action-item {
  margin-left: 48px;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 14px 20px 0;
  box-sizing: border-box;
}

.pagination-seq {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px 12px;
}

/* 媒体列：缩略图网格 + 预览弹窗 */
.media-cell {
  line-height: 1.4;
}

.media-summary {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
}

.media-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
}

.media-item {
  cursor: pointer;
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
  overflow: hidden;
}

.under-dot {
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
  bottom: 0;
  position: absolute;
  right: 0;
  width: 16px;
  height: 16px;
  font-size: 12px;
  border-radius: 2px;
}

.media-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  display: block;
}

.media-video {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
  font-size: 16px;
}

.media-preview {
  max-width: 100%;
  max-height: 70vh;
  display: block;
  margin: 0 auto;
}

/* 预览弹窗内容容器 + 上一张/下一张导航 */
.media-preview-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 600px;
  overflow-y: auto;
}

.media-preview-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
}

.media-preview-count {
  min-width: 48px;
  text-align: center;
  font-size: 14px;
  color: #606266;
}

/* 关联话题 tag 间距 */
.topic-tag {
  margin: 2px 4px 2px 0;
}

.status-tab-btn {
  min-width: 64px;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #409eff;
  border-radius: 0;
  color: #409eff;
  background: #fff;
  font-size: 14px;
}

.status-tab-btn.is-active {
  background: #409eff;
  color: #fff;
}
</style>

<style>
.el-table__body,
.el-table__header {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// ReportManage.vue?2e76f4b6